import { surveysConstants } from '../constants';

export const surveysActions = {
    getSurveys: () => ({ type: surveysConstants.GET_MY_REQUEST}), 
    getSurveyDetail: (EncuestaID) => ({ type: surveysConstants.GET_SURVEY_DETAIL_REQUEST, EncuestaID }),     
    searchSurvey: (surveyQuery) => ({ type: surveysConstants.SEARCH_SURVEYS, surveyQuery }),    
    clearSearchSurvey: () => ({ type: surveysConstants.SEARCH_SURVEYS_CLEAR }),
    sendSurvey: (data) => ({ type: surveysConstants.SEND_SURVEY_REQUEST, data }),
    changeView:(vista) => ({ type: surveysConstants.SURVEY_CHANGE_VIEW, vista }),
};